/* eslint-disable jsx-a11y/anchor-is-valid */

import { useEffect } from 'react';
import { themeVariables } from '../helpers/helpers';
import { getThemeUnAuth } from '../api/queries';
import Loading from './loading';
// import LanguageSelector from '../components/languageSelector';

function BasicLayout(props) {
  const theme = getThemeUnAuth();
  const { children } = props;

  useEffect(() => {
    if (theme.isSuccess) {
      document.title = `${theme?.data?.display_name} Portal`;
    }
  }, [theme]);

  if (!theme?.data) {
    return <Loading />;
  }

  const { darkColour, grad1Colour, grad2Colour } = themeVariables(theme);

  return (

    <div className="">
      <div
        style={{ background: `radial-gradient(${grad1Colour}, ${grad2Colour})` }}
        className="min-h-screen-minus-footer text-white py-10"
      >
        {/* <div className="flex flex-row-reverse pr-10">
          <LanguageSelector />
        </div> */}
        {children}
      </div>
      <div style={{ backgroundColor: darkColour }} className="text-white text-sm p-2 h-14 flex items-center">
        <div className="container mx-auto flex flex-wrap ">
          <div className="w-full lg:w-1/2">
            &copy;
            {' '}
            {theme?.data?.display_name}
            {' '}
            2022
          </div>
        </div>
      </div>
    </div>

  );
}
export default BasicLayout;
